import { Heading } from 'components/text';

import styles from './VaultBenefits.module.scss';
import BenefitItem from './BenefitItem';

import Container from 'components/container';

const VaultBenefits: React.FC = () => (
  <Container className={styles.container}>
    <BenefitItem
      title="Premier benefits for hotel partners"
      description={
        <Heading as="h5" weight="regular">
          By joining Vault, your hotel will <strong>stand out</strong> and
          benefit from complimentary marketing and social media exposure,
          driving <strong>more bookings</strong> and{' '}
          <strong>enhancing your reputation</strong> within our luxury network.
        </Heading>
      }
    />
    <BenefitItem
      title="Flexible and hassle-free partnership"
      description={
        <>
          <Heading as="h5" weight="regular">
            Vault membership is simple and <strong>cost-free</strong>, with all
            bookings seamlessly managed through our platform.
          </Heading>
          <Heading as="h5" weight="regular">
            With a 12-month rolling term and easy exit options, Vault offers
            flexibility and peace of mind.
          </Heading>
        </>
      }
    />
    <BenefitItem
      title="Connect with our MyLER network"
      description={
        <>
          <Heading as="h5" weight="regular">
            Vault offers <strong>exclusive opportunities</strong> to engage with
            our growing MyLER community of Independent Travel Advisors. Leverage
            newsletters, webinars and FAM trips to showcase your property.
          </Heading>
          <Heading as="h5" weight="regular">
            Additionally, gain <strong>special recognition</strong> through our
            ‘MyLER High Club’, further{' '}
            <strong>enhancing your visibility</strong> within our MyLER
            community.
          </Heading>
        </>
      }
    />
  </Container>
);

export default VaultBenefits;
